export enum CircuitDiagramType {
  'SYS' = '系统电路图',
  'LOC' = '位置图',
  'CON' = '端子图信息',
  'RCL' = '布置图',
  'FRB' = '电器盒信息',
  'GND' = '配置对照表'
}
export enum TREE_TYPE {
  BOOK_MAP = 'BOOKMAP',
  CHAPTER = 'CHAPTER',
  TOPIC_REF = 'TOPICREF',
  TOPIC = 'TOPIC'
}
